@file:OptIn(InternalResourceApi::class)

package kinoshazam.resources.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/kinoshazam.resources.generated.resources/"

public val Res.drawable.action: DrawableResource by lazy {
      DrawableResource("drawable:action", setOf(
        ResourceItem(setOf(), "${MD}drawable/action.xml", -1, -1),
      ))
    }

public val Res.drawable.adventures: DrawableResource by lazy {
      DrawableResource("drawable:adventures", setOf(
        ResourceItem(setOf(), "${MD}drawable/adventures.xml", -1, -1),
      ))
    }

public val Res.drawable.arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_right.xml", -1, -1),
      ))
    }

public val Res.drawable.back: DrawableResource by lazy {
      DrawableResource("drawable:back", setOf(
        ResourceItem(setOf(), "${MD}drawable/back.xml", -1, -1),
      ))
    }

public val Res.drawable.biografy: DrawableResource by lazy {
      DrawableResource("drawable:biografy", setOf(
        ResourceItem(setOf(), "${MD}drawable/biografy.xml", -1, -1),
      ))
    }

public val Res.drawable.cartoon: DrawableResource by lazy {
      DrawableResource("drawable:cartoon", setOf(
        ResourceItem(setOf(), "${MD}drawable/cartoon.xml", -1, -1),
      ))
    }

public val Res.drawable.children: DrawableResource by lazy {
      DrawableResource("drawable:children", setOf(
        ResourceItem(setOf(), "${MD}drawable/children.xml", -1, -1),
      ))
    }

public val Res.drawable.close: DrawableResource by lazy {
      DrawableResource("drawable:close", setOf(
        ResourceItem(setOf(), "${MD}drawable/close.xml", -1, -1),
      ))
    }

public val Res.drawable.comedy: DrawableResource by lazy {
      DrawableResource("drawable:comedy", setOf(
        ResourceItem(setOf(), "${MD}drawable/comedy.xml", -1, -1),
      ))
    }

public val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

public val Res.drawable.criminal: DrawableResource by lazy {
      DrawableResource("drawable:criminal", setOf(
        ResourceItem(setOf(), "${MD}drawable/criminal.xml", -1, -1),
      ))
    }

public val Res.drawable.detective: DrawableResource by lazy {
      DrawableResource("drawable:detective", setOf(
        ResourceItem(setOf(), "${MD}drawable/detective.xml", -1, -1),
      ))
    }

public val Res.drawable.dice: DrawableResource by lazy {
      DrawableResource("drawable:dice", setOf(
        ResourceItem(setOf(), "${MD}drawable/dice.xml", -1, -1),
      ))
    }

public val Res.drawable.drama: DrawableResource by lazy {
      DrawableResource("drawable:drama", setOf(
        ResourceItem(setOf(), "${MD}drawable/drama.xml", -1, -1),
      ))
    }

public val Res.drawable.edit: DrawableResource by lazy {
      DrawableResource("drawable:edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit.xml", -1, -1),
      ))
    }

public val Res.drawable.enter_fullscreen: DrawableResource by lazy {
      DrawableResource("drawable:enter_fullscreen", setOf(
        ResourceItem(setOf(), "${MD}drawable/enter-fullscreen.svg", -1, -1),
      ))
    }

public val Res.drawable.exit_fullscreen: DrawableResource by lazy {
      DrawableResource("drawable:exit_fullscreen", setOf(
        ResourceItem(setOf(), "${MD}drawable/exit-fullscreen.svg", -1, -1),
      ))
    }

public val Res.drawable.family: DrawableResource by lazy {
      DrawableResource("drawable:family", setOf(
        ResourceItem(setOf(), "${MD}drawable/family.xml", -1, -1),
      ))
    }

public val Res.drawable.fantastic: DrawableResource by lazy {
      DrawableResource("drawable:fantastic", setOf(
        ResourceItem(setOf(), "${MD}drawable/fantastic.xml", -1, -1),
      ))
    }

public val Res.drawable.favourites: DrawableResource by lazy {
      DrawableResource("drawable:favourites", setOf(
        ResourceItem(setOf(), "${MD}drawable/favourites.xml", -1, -1),
      ))
    }

public val Res.drawable.fentesy: DrawableResource by lazy {
      DrawableResource("drawable:fentesy", setOf(
        ResourceItem(setOf(), "${MD}drawable/fentesy.xml", -1, -1),
      ))
    }

public val Res.drawable.fill_favorite: DrawableResource by lazy {
      DrawableResource("drawable:fill_favorite", setOf(
        ResourceItem(setOf(), "${MD}drawable/fill_favorite.xml", -1, -1),
      ))
    }

public val Res.drawable.film: DrawableResource by lazy {
      DrawableResource("drawable:film", setOf(
        ResourceItem(setOf(), "${MD}drawable/film.xml", -1, -1),
      ))
    }

public val Res.drawable.full_logo: DrawableResource by lazy {
      DrawableResource("drawable:full_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/full_logo.xml", -1, -1),
      ))
    }

public val Res.drawable.history: DrawableResource by lazy {
      DrawableResource("drawable:history", setOf(
        ResourceItem(setOf(), "${MD}drawable/history.xml", -1, -1),
      ))
    }

public val Res.drawable.icon_app: DrawableResource by lazy {
      DrawableResource("drawable:icon_app", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_app.xml", -1, -1),
      ))
    }

public val Res.drawable.info: DrawableResource by lazy {
      DrawableResource("drawable:info", setOf(
        ResourceItem(setOf(), "${MD}drawable/info.xml", -1, -1),
      ))
    }

public val Res.drawable.kinoshka: DrawableResource by lazy {
      DrawableResource("drawable:kinoshka", setOf(
        ResourceItem(setOf(), "${MD}drawable/kinoshka.xml", -1, -1),
      ))
    }

public val Res.drawable.korotkometr: DrawableResource by lazy {
      DrawableResource("drawable:korotkometr", setOf(
        ResourceItem(setOf(), "${MD}drawable/korotkometr.xml", -1, -1),
      ))
    }

public val Res.drawable.left: DrawableResource by lazy {
      DrawableResource("drawable:left", setOf(
        ResourceItem(setOf(), "${MD}drawable/left.xml", -1, -1),
      ))
    }

public val Res.drawable.logout: DrawableResource by lazy {
      DrawableResource("drawable:logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/logout.xml", -1, -1),
      ))
    }

public val Res.drawable.magic_wand: DrawableResource by lazy {
      DrawableResource("drawable:magic_wand", setOf(
        ResourceItem(setOf(), "${MD}drawable/magic_wand.xml", -1, -1),
      ))
    }

public val Res.drawable.melodrama: DrawableResource by lazy {
      DrawableResource("drawable:melodrama", setOf(
        ResourceItem(setOf(), "${MD}drawable/melodrama.xml", -1, -1),
      ))
    }

public val Res.drawable.menu: DrawableResource by lazy {
      DrawableResource("drawable:menu", setOf(
        ResourceItem(setOf(), "${MD}drawable/menu.xml", -1, -1),
      ))
    }

public val Res.drawable.movie: DrawableResource by lazy {
      DrawableResource("drawable:movie", setOf(
        ResourceItem(setOf(), "${MD}drawable/movie.xml", -1, -1),
      ))
    }

public val Res.drawable.pause: DrawableResource by lazy {
      DrawableResource("drawable:pause", setOf(
        ResourceItem(setOf(), "${MD}drawable/pause.xml", -1, -1),
      ))
    }

public val Res.drawable.placeholder: DrawableResource by lazy {
      DrawableResource("drawable:placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/placeholder.xml", -1, -1),
      ))
    }

public val Res.drawable.play: DrawableResource by lazy {
      DrawableResource("drawable:play", setOf(
        ResourceItem(setOf(), "${MD}drawable/play.xml", -1, -1),
      ))
    }

public val Res.drawable.remove: DrawableResource by lazy {
      DrawableResource("drawable:remove", setOf(
        ResourceItem(setOf(), "${MD}drawable/remove.xml", -1, -1),
      ))
    }

public val Res.drawable.right: DrawableResource by lazy {
      DrawableResource("drawable:right", setOf(
        ResourceItem(setOf(), "${MD}drawable/right.xml", -1, -1),
      ))
    }

public val Res.drawable.search: DrawableResource by lazy {
      DrawableResource("drawable:search", setOf(
        ResourceItem(setOf(), "${MD}drawable/search.xml", -1, -1),
      ))
    }

public val Res.drawable.settings: DrawableResource by lazy {
      DrawableResource("drawable:settings", setOf(
        ResourceItem(setOf(), "${MD}drawable/settings.xml", -1, -1),
      ))
    }

public val Res.drawable.share: DrawableResource by lazy {
      DrawableResource("drawable:share", setOf(
        ResourceItem(setOf(), "${MD}drawable/share.xml", -1, -1),
      ))
    }

public val Res.drawable.share_app: DrawableResource by lazy {
      DrawableResource("drawable:share_app", setOf(
        ResourceItem(setOf(), "${MD}drawable/share_app.xml", -1, -1),
      ))
    }

public val Res.drawable.short_logo: DrawableResource by lazy {
      DrawableResource("drawable:short_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/short_logo.xml", -1, -1),
      ))
    }

public val Res.drawable.sort: DrawableResource by lazy {
      DrawableResource("drawable:sort", setOf(
        ResourceItem(setOf(), "${MD}drawable/sort.xml", -1, -1),
      ))
    }

public val Res.drawable.speed: DrawableResource by lazy {
      DrawableResource("drawable:speed", setOf(
        ResourceItem(setOf(), "${MD}drawable/speed.svg", -1, -1),
      ))
    }

public val Res.drawable.sport: DrawableResource by lazy {
      DrawableResource("drawable:sport", setOf(
        ResourceItem(setOf(), "${MD}drawable/sport.xml", -1, -1),
      ))
    }

public val Res.drawable.triller: DrawableResource by lazy {
      DrawableResource("drawable:triller", setOf(
        ResourceItem(setOf(), "${MD}drawable/triller.xml", -1, -1),
      ))
    }

public val Res.drawable.tv_show: DrawableResource by lazy {
      DrawableResource("drawable:tv_show", setOf(
        ResourceItem(setOf(), "${MD}drawable/tv_show.xml", -1, -1),
      ))
    }

public val Res.drawable.update: DrawableResource by lazy {
      DrawableResource("drawable:update", setOf(
        ResourceItem(setOf(), "${MD}drawable/update.xml", -1, -1),
      ))
    }

public val Res.drawable.uzhas: DrawableResource by lazy {
      DrawableResource("drawable:uzhas", setOf(
        ResourceItem(setOf(), "${MD}drawable/uzhas.xml", -1, -1),
      ))
    }

public val Res.drawable.voenniy: DrawableResource by lazy {
      DrawableResource("drawable:voenniy", setOf(
        ResourceItem(setOf(), "${MD}drawable/voenniy.xml", -1, -1),
      ))
    }

public val Res.drawable.voenniy_2: DrawableResource by lazy {
      DrawableResource("drawable:voenniy_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/voenniy_2.xml", -1, -1),
      ))
    }

public val Res.drawable.volume: DrawableResource by lazy {
      DrawableResource("drawable:volume", setOf(
        ResourceItem(setOf(), "${MD}drawable/volume.svg", -1, -1),
      ))
    }

public val Res.drawable.western: DrawableResource by lazy {
      DrawableResource("drawable:western", setOf(
        ResourceItem(setOf(), "${MD}drawable/western.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("action", Res.drawable.action)
  map.put("adventures", Res.drawable.adventures)
  map.put("arrow_right", Res.drawable.arrow_right)
  map.put("back", Res.drawable.back)
  map.put("biografy", Res.drawable.biografy)
  map.put("cartoon", Res.drawable.cartoon)
  map.put("children", Res.drawable.children)
  map.put("close", Res.drawable.close)
  map.put("comedy", Res.drawable.comedy)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("criminal", Res.drawable.criminal)
  map.put("detective", Res.drawable.detective)
  map.put("dice", Res.drawable.dice)
  map.put("drama", Res.drawable.drama)
  map.put("edit", Res.drawable.edit)
  map.put("enter_fullscreen", Res.drawable.enter_fullscreen)
  map.put("exit_fullscreen", Res.drawable.exit_fullscreen)
  map.put("family", Res.drawable.family)
  map.put("fantastic", Res.drawable.fantastic)
  map.put("favourites", Res.drawable.favourites)
  map.put("fentesy", Res.drawable.fentesy)
  map.put("fill_favorite", Res.drawable.fill_favorite)
  map.put("film", Res.drawable.film)
  map.put("full_logo", Res.drawable.full_logo)
  map.put("history", Res.drawable.history)
  map.put("icon_app", Res.drawable.icon_app)
  map.put("info", Res.drawable.info)
  map.put("kinoshka", Res.drawable.kinoshka)
  map.put("korotkometr", Res.drawable.korotkometr)
  map.put("left", Res.drawable.left)
  map.put("logout", Res.drawable.logout)
  map.put("magic_wand", Res.drawable.magic_wand)
  map.put("melodrama", Res.drawable.melodrama)
  map.put("menu", Res.drawable.menu)
  map.put("movie", Res.drawable.movie)
  map.put("pause", Res.drawable.pause)
  map.put("placeholder", Res.drawable.placeholder)
  map.put("play", Res.drawable.play)
  map.put("remove", Res.drawable.remove)
  map.put("right", Res.drawable.right)
  map.put("search", Res.drawable.search)
  map.put("settings", Res.drawable.settings)
  map.put("share", Res.drawable.share)
  map.put("share_app", Res.drawable.share_app)
  map.put("short_logo", Res.drawable.short_logo)
  map.put("sort", Res.drawable.sort)
  map.put("speed", Res.drawable.speed)
  map.put("sport", Res.drawable.sport)
  map.put("triller", Res.drawable.triller)
  map.put("tv_show", Res.drawable.tv_show)
  map.put("update", Res.drawable.update)
  map.put("uzhas", Res.drawable.uzhas)
  map.put("voenniy", Res.drawable.voenniy)
  map.put("voenniy_2", Res.drawable.voenniy_2)
  map.put("volume", Res.drawable.volume)
  map.put("western", Res.drawable.western)
}
